import { create } from 'zustand';

interface NotificationProcessingState {
  isProcessing: boolean;
  setIsProcessing: (processing: boolean) => void;
}

export const useNotificationProcessingState = create<NotificationProcessingState>((set) => ({
  isProcessing: false,
  setIsProcessing: (processing: boolean) => set({ isProcessing: processing })
}));
